export const _en = {
    code: {
        label: "Code event"
    },
    description: {
        label: "Description"
    },
    divisionId: {
        label: "Division"
    },
    refCodeEventCategoryId: {
        label: "Category code event"
    }
};

export const _fr = {
    code: {
        label: "Code évènement"
    },
    description: {
        label: "Description"
    },
    divisionId: {
        label: "Service"
    },
    refCodeEventCategoryId: {
        label: "Catégorie d'application"
    }
};